angular.module("Main").factory("CurrencyDataService", ["$http", "$q", "NODEBACKEND",
    function ($http, $q, NODEBACKEND) {

        return {
            loadCurrencyConfiguration: loadCurrencyConfiguration
        };

        function loadCurrencyConfiguration() {
            return $http.get(NODEBACKEND + "/onlinesales/settings/currency").then(function (response) {
                return response.data.currency;
            })
        }
    }]);